import { render } from "./SportSelection.vue?vue&type=template&id=2ec1e17d&scoped=true"
import script from "./SportSelection.vue?vue&type=script&lang=js"
export * from "./SportSelection.vue?vue&type=script&lang=js"

import "./SportSelection.vue?vue&type=style&index=0&id=2ec1e17d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec1e17d"]])

export default __exports__